import { createBrowserRouter, Navigate } from "react-router";
import { ProtectedRoute } from "@/shared/auth/ProtectedRoute";
import { AppLayout } from "./AppLayout";

// Все страницы — lazy() (07-admin.md §5: цель < 250 КБ gzip начального чанка).
export const router = createBrowserRouter([
  {
    path: "/login",
    lazy: async () => ({ Component: (await import("@/features/auth/LoginPage")).default }),
  },
  {
    path: "/totp",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/enroll",
    element: <Navigate to="/login" replace />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <Navigate to="/config/looks" replace /> },
          {
            path: "config",
            lazy: async () => ({
              Component: (await import("@/features/config/ConfigSection")).default,
            }),
            children: [
              {
                path: "looks",
                lazy: async () => ({
                  Component: (await import("@/features/config/LooksPage")).default,
                }),
              },
              {
                path: "onboardings",
                lazy: async () => ({
                  Component: (await import("@/features/config/OnboardingsPage")).default,
                }),
              },
              {
                path: "paywalls",
                lazy: async () => ({
                  Component: (await import("@/features/config/PaywallsPage")).default,
                }),
              },
              {
                path: "flags",
                lazy: async () => ({
                  Component: (await import("@/features/config/FlagsPage")).default,
                }),
              },
              {
                path: "revisions",
                lazy: async () => ({
                  Component: (await import("@/features/config/RevisionsPage")).default,
                }),
              },
              {
                path: "products",
                lazy: async () => ({
                  Component: (await import("@/features/config/ProductsPage")).default,
                }),
              },
            ],
          },
          {
            path: "analytics/funnels",
            lazy: async () => ({
              Component: (await import("@/features/analytics/FunnelsPage")).default,
            }),
          },
          {
            path: "analytics/experiments",
            lazy: async () => ({
              Component: (await import("@/features/analytics/ExperimentsPage")).default,
            }),
          },
          {
            path: "system/sessions",
            lazy: async () => ({
              Component: (await import("@/features/system/SessionsPage")).default,
            }),
          },
        ],
      },
    ],
  },
  {
    path: "*",
    lazy: async () => ({ Component: (await import("./NotFoundPage")).default }),
  },
]);
